import React, { Component } from 'react';
import './PaywallModal.css';

const DRAWER_MS = 320;

// Light haptic tap on supported mobile browsers (e.g. Android Chrome)
const triggerPayVibration = () => {
  if (typeof window === 'undefined') {
    return;
  }
  if (!window.matchMedia('(max-width: 480px)').matches) {
    return;
  }
  if (window.navigator && typeof window.navigator.vibrate === 'function') {
    window.navigator.vibrate(15);
  }
};

// Paywall modal before Lemon checkout — purchase CTA (not an ad)
class PaywallModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false,
      open: false,
    };
    this.closeTimer = null;
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.openDrawer();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.openDrawer();
    }
    if (prevProps.isOpen && !this.props.isOpen) {
      this.closeDrawer();
    }
  }

  componentWillUnmount() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
  }

  // Mount sheet then slide up on next frame (mobile CSS handles motion)
  openDrawer = () => {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    this.setState({ mounted: true, open: false }, () => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.setState({ open: true });
        });
      });
    });
  };

  // Slide down then unmount after transition
  closeDrawer = () => {
    this.setState({ open: false });
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
    this.closeTimer = setTimeout(() => {
      this.setState({ mounted: false });
      this.closeTimer = null;
    }, DRAWER_MS);
  };

  // Close button / overlay — parent flips isOpen; we animate out via closeDrawer
  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  // Pay CTA: mobile vibration then open Lemon checkout
  handlePayClick = () => {
    triggerPayVibration();
    if (this.props.onPay) {
      this.props.onPay();
    }
  };

  render() {
    const { loading, priceLabel } = this.props;
    const { mounted, open } = this.state;
    if (!mounted) {
      return null;
    }

    const price = priceLabel || 'USD $1.49';
    const overlayClass = open
      ? 'paywall-overlay paywall-overlay-open'
      : 'paywall-overlay';

    return (
      <div className={overlayClass} onClick={this.handleClose} role="presentation">
        <div
          className="paywall-card paywall-card-rich"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-labelledby="paywall-title"
        >
          <button type="button" className="paywall-close" onClick={this.handleClose} aria-label="Close">
            ×
          </button>

          <p className="paywall-badge">One-time video export</p>
          <h2 id="paywall-title" className="paywall-title">
            Ready to download your LED video?
          </h2>
          <p className="paywall-text paywall-text-full">
            Designing and live preview stay free. Pay once to export a finished scrolling LED
            video you can use on screens, shops, events, and social posts.
          </p>
          <p className="paywall-text paywall-text-compact">
            Design &amp; preview stay free. Pay once to export your LED video.
          </p>

          <div className="paywall-preview" aria-hidden="true">
            <div className="paywall-preview-screen">
              <div className="paywall-preview-track">
                <span className="paywall-preview-text">YOUR LED MESSAGE · READY TO DOWNLOAD · </span>
                <span className="paywall-preview-text">YOUR LED MESSAGE · READY TO DOWNLOAD · </span>
              </div>
            </div>
            <p className="paywall-preview-caption">Preview stays free · Export unlocks after payment</p>
          </div>

          <ul className="paywall-benefits">
            <li>Instant download after secure checkout</li>
            <li>Keep Order ID + Access Code to recover anytime</li>
            <li className="paywall-benefit-extra">No subscription — pay once for this export</li>
            <li className="paywall-benefit-extra">Design tools remain free forever</li>
          </ul>

          <div className="paywall-actions">
            <div className="paywall-price-row">
              <div>
                <p className="paywall-price-label">One-time price</p>
                <p className="paywall-price">{price}</p>
              </div>
              <p className="paywall-price-note">Secure checkout · No account required</p>
            </div>

            <button
              type="button"
              className="paywall-cta"
              onClick={this.handlePayClick}
              disabled={loading}
            >
              {loading ? 'Opening checkout…' : `Pay & unlock — ${price}`}
            </button>
            <button type="button" className="paywall-secondary" onClick={this.props.onRecover}>
              Already paid? Recover download
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default PaywallModal;
